"use client";

import React from "react";
import { MessageSquare, Phone } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  const defaultMascot = {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/8cc77ff8-9509-4afd-995d-58f58605cc2a.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/8cc77ff8-9509-4afd-995d-58f58605cc2a.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/8cc77ff8-9509-4afd-995d-58f58605cc2a.png-wvc-sizes",
    alt: "Robot mascot ROBOTO tự tin"
  };
  const channels = [{
    name: "Zalo",
    status: "Sắp cập nhật",
    available: false
  }, {
    name: "Messenger",
    status: "Sắp cập nhật",
    available: false
  }];
  return <section id="facilitiesconsultationcta" data-nav="light" className="relative w-full border-y border-border bg-background/95 py-6 backdrop-blur-xs">
      {/* Precision Lime Green spec rail accent at the top boundary */}
      <div className="absolute inset-x-0 top-0 h-[2px] bg-secondary" />

      {/* Static Floating Decorative Mascot */}
      <div className="pointer-events-none absolute -top-10 right-6 z-10 hidden select-none sm:-top-12 sm:right-8 sm:block lg:-top-14 lg:right-12" aria-hidden="true">
        <img src={defaultMascot.src} data-wvc-srcset={defaultMascot.srcset} data-wvc-sizes={defaultMascot.sizes} alt={defaultMascot.alt} className="size-20 select-none bg-transparent object-contain drop-shadow-md pointer-events-none sm:size-24 lg:size-28" loading="lazy" />
      </div>

      <div className="relative z-20 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 8
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: "easeOut"
      }} className="flex flex-col items-center justify-between gap-5 lg:flex-row lg:gap-8">
          {/* Main Inquiry Headline */}
          <div className="flex flex-1 items-center gap-3 text-center lg:text-left">
            <h2 className="font-serif text-lg font-semibold tracking-tight text-foreground sm:text-xl lg:text-2xl">
              Ba mẹ băn khoăn cơ sở nào gần và thuận tiện nhất cho con?
            </h2>
          </div>

          {/* Action Row: Primary Button + Quick-Contact Channel Group */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 lg:justify-end">
            {/* Primary Action Button */}
            <motion.div whileHover={shouldReduceMotion ? undefined : {
            y: -2
          }} whileTap={shouldReduceMotion ? undefined : {
            y: 0
          }}>
              <Button asChild size="lg" className="rounded-lg bg-accent px-6 py-2.5 font-bold tracking-wide text-accent-foreground shadow-sm transition-[background-color,box-shadow] hover:bg-accent/90">
                <Link to="/FreeTrialContactPage">ĐĂNG KÝ TƯ VẤN</Link>
              </Button>
            </motion.div>

            {/* Quick Contact Options */}
            <div className="flex flex-wrap items-center gap-2 border-border/80 sm:border-l sm:pl-4">
              {channels.map((channel, i) => <div key={channel.name} data-index={i} className="flex items-center gap-1.5 rounded-md border border-border/60 bg-muted/40 px-2.5 py-1.5 text-xs text-muted-foreground opacity-75 select-none" aria-disabled="true">
                  <MessageSquare className="size-3.5 text-muted-foreground/70" />
                  <span className="font-medium text-foreground/80">{channel.name}</span>
                  <Badge variant="outline" className="border-border bg-background/80 px-1.5 py-0 text-[10px] text-muted-foreground">
                    {channel.status}
                  </Badge>
                </div>)}

              {/* Direct Hotline Option */}
              <motion.div whileHover={shouldReduceMotion ? undefined : {
              scale: 1.02
            }} whileTap={shouldReduceMotion ? undefined : {
              scale: 0.98
            }}>
                <a href="tel:0346386986" className="group inline-flex items-center gap-2 rounded-md border border-secondary/30 bg-secondary/10 px-3 py-1.5 text-xs font-semibold text-secondary-foreground transition-[background-color,border-color,box-shadow] hover:border-secondary hover:bg-secondary/20 hover:shadow-xs focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none">
                  <Phone className="size-3.5 text-secondary" />
                  <span className="text-muted-foreground group-hover:text-foreground">
                    Gọi Hotline:
                  </span>
                  <span className="font-bold text-foreground">0346 386 986</span>
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}